import { Box, Typography, TextFieldProps, Alert } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useRef } from 'react'
import { Navigate } from 'react-router-dom'
import InputBase from 'design-system/input/base'
import ButtonBase from 'design-system/button'
import useLogin from './useLogin'
import InputPassword from 'design-system/input/password'
import { FORGOT_PASSWORD } from 'navigation/CONSTANTS'
import NavLinkBase from 'design-system/NavLink'
import { useLogo } from 'hooks/useLogo'
import { SaLogo } from 'components/SaLogo'

export const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  gap: theme.spacing(2),
  maxWidth: '500px',
  padding: '0 40px',
  margin: '0 auto'
}))

export const LogoSaContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginTop: theme.spacing(2),
  gap: theme.spacing(2)
}))

const LoginPage = () => {
  // states
  const { state, login, message } = useLogin()
  const logo = useLogo()
  // refs
  const emailInputRef = useRef<TextFieldProps>()
  const passwordInputRef = useRef<TextFieldProps>()

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    e.stopPropagation()
    const email = (emailInputRef.current?.value as string).trim() ?? ''
    const password = (passwordInputRef.current?.value as string) ?? ''
    login(email, password)
  }

  if (state === 'success') {
    return <Navigate to='/' />
  }

  return (
    <form onSubmit={onSubmit}>
      <StyledBox>
        <img src={logo} alt='Sentinela' style={{ width: '300px' }} />
        <InputBase label='E-mail' variant='outlined' inputRef={emailInputRef} />
        <InputPassword
          label='Senha'
          type='password'
          variant='outlined'
          inputRef={passwordInputRef}
        />
        <ButtonBase
          type='submit'
          sx={{ mt: 2, width: '100%' }}
          disabled={state === 'loading'}
        >
          Entrar
        </ButtonBase>
        <NavLinkBase to={`${FORGOT_PASSWORD}`}>
          <Typography variant='body2' color='textSecondary'>
            Esqueceu sua senha?
          </Typography>
        </NavLinkBase>
        {state === 'error' && (
          <Alert
            severity='error'
            style={{ width: '100%', marginTop: 16, justifyContent: 'center' }}
          >
            {message}
          </Alert>
        )}
        <Box mt={4}>
          <Typography variant='body2' style={{ marginTop: 16 }}>
            Powered by
          </Typography>
          <SaLogo />
        </Box>
      </StyledBox>
    </form>
  )
}

export default LoginPage
